// Countertops/Cabinets — capability flags derived from the EXISTING RBAC permission tree.
//
// No new authorization architecture: this reuses `Admin.userMenuList[0].permission`
// (from USER_MENU_LIST_REQUEST) exactly as Estimates.jsx does — the "Estimating Customer Info"
// module permission (menuId 5) gates estimate editing, so the manual C/C calculator (reached from
// that same module) reuses it. Server-side authorization remains the source of truth; these flags
// only shape the UI.

// menuId of "Estimating Customer Info" — the module the manual calculator lives under
// (same id Estimates.jsx uses to gate quantity editing).
export const ESTIMATING_CUSTOMER_INFO_MENU_ID = 5;

const getPermissions = (userMenuList) => userMenuList?.[0]?.permission || [];

// Capability flags for the manual calculator.
// canView : open the calculator.
// canEdit : add scopes, edit QTY / Unit Price, save the estimate.
//
// Until the RBAC permission tree has loaded (empty list) we default permissive so the UI is not
// blocked on first paint — the SERVER remains the authoritative gate. Once the tree is loaded,
// the "Estimating Customer Info" permission (menuId 5, status true) governs editing; absence
// of that permission denies editing while still allowing view.
export function deriveCountertopCabinetPermissions(userMenuList) {
  const permissions = getPermissions(userMenuList);
  if (permissions.length === 0) {
    return { canView: true, canEdit: true };
  }
  const allowed = permissions.some(
    (p) => p.menuId === ESTIMATING_CUSTOMER_INFO_MENU_ID && p.status === true
  );
  return {
    canView: true, // reaching the route implies the customer is visible; editing is the gate
    canEdit: allowed,
  };
}
